var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"tip"},[_c('span',[_vm._v("just do it")]),_c('router-link',{attrs:{"to":{ path: '/home' }}},[_c('div',{staticClass:"viewmore",staticStyle:{"cursor":"pointer"}},[_c('p',[_vm._v("Begin")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }